// noinspection SpellCheckingInspection

export const environment = {
  production: true,
  serviceUrl: 'https://service.manager.smuk.co.uk/api',
  environment: 'live',
  version: '74811c6e75a81c4ef6232e0c56d7780172d11f46-20261105090249',
  authMethods: 'password',
  inputDebounceTime: 500,
  browserWaitTime: 100,
  sentryDSN: 'https://029a58f2e71192bdb1c0469eaed4768c@o4510148473782272.ingest.de.sentry.io/4511105413218384',
  invoicingCutOff: new Date('2026-06-19'),
  echo: {
    key: 'oddpk4z8bhqwmjzt7f3m',
  },
  reverb: {
    cluster: '',
    wsHost: 'service.manager.smuk.co.uk',
    wsPort: 80,
    wssPort: 443,
    forceTLS: true,
  },
}
